import AddFromBabylistStore from './add-from-babylist-store'

export default AddFromBabylistStore
